module.exports = __webpack_public_path__ + "logo.110a38980e3ca9f21379.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 717
// module chunks = 13